import React from "react";
import HeadingText from "./Heading";
import SubheadingText from "./Subheading";
import ParagraphText from "./Paragraph";
import LotusLogo from "./Logo";
import Footer from "./Footer";
import { Wrapper, Break } from "../styles/components/Global/Global";

const SectionPetals = () => {
  return (
    <Wrapper className="scene-switch footer">
      <Wrapper $margin>
        <HeadingText text="Petals in the wind" />
        <ParagraphText
          text="Ksawery admits that since getting to take a spin in the Eletre, he looks at his own car and notices, despite being a model released just ten years ago, it seems decidedly retro compared to the Lotus. "
          align="center"
          width="small"
          textAlign="left"
          indent={true}
          bold={true}
        />
        <SubheadingText
          text="“I was so impressed by how futuristic it felt. The car doesn’t have mirrors, for example, but a series of high-res cameras instead.” His astonishment also extended to the intense reverberations of the audio system. “They’ve built this amazing Dolby Atmos surround system. When I was sitting in the car listening to music, it felt like I was inside a theater.”  "
          width="small"
          textAlign="left"
        />
        <Break $size="small" />
        <ParagraphText
          text="When asked what the soundtrack would be next time he was behind the wheel of a Lotus blasting full speed down the motorway, Ksawery was quick to answer with an undeniable crowd pleaser, “Easy! Autobahn, by Kraftwerk.”"
          width="xlarge"
          size="large"
          align="flex-start"
          textAlign="left"
        />
        <Break $size="medium" />
        <LotusLogo
          source="https://www.datocms-assets.com/40484/1694885842-logo-wordmark.png"
          margin={true}
          link={true}
        />
        <Break $size="medium" />
      </Wrapper>
      <Footer />
    </Wrapper>
  );
};

export default SectionPetals;
